export function isInConstructionMode(): boolean {
  return $('body').hasClass('construction-mode');
}
